export default __webpack_public_path__ + "static/media/DurhamPropertyConsultants.d28a9ccd.jpg";